<app-loader *ngIf="(isLoading$ | async) === true; else loaded"></app-loader>
<ng-template #loaded>
  <app-competitions-short-list-cmp
    [current]="current$ | async"
    [upcoming]="upcoming$ | async"
    [previous]="previous$ | async"
  ></app-competitions-short-list-cmp>
</ng-template>
